<template>
  <b-modal
    v-model="value"
    :title="$t('tasks.guideModal.title')"
    size="lg"
    hide-footer
    no-enforce-focus
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    centered
    @input="$emit('input', $event)"
  >
    <template v-if="loading">
      <div class="text-center py-4">
        <b-spinner />
        <p class="mt-2 mb-0 text-muted">
          {{ $t('common.loading') }}
        </p>
      </div>
    </template>
    <template v-else>
      <p class="text-muted small mb-1">
        {{ $t('tasks.guideModal.info') }}
      </p>
      <b-form-group
        :label="$t('common.searchLabel')"
        label-for="search"
      >
        <b-input-group>
          <b-form-input
            v-model="search"
            :placeholder="$t('common.search')"
            @keydown.enter="loadGuides"
          />
          <template #append>
            <b-button
              variant="outline-secondary"
              @click="loadGuides"
            >
              <feather-icon icon="SearchIcon" />
            </b-button>
          </template>
        </b-input-group>
      </b-form-group>
      <b-list-group
        v-if="guidesList.length > 0"
        class="mb-0"
      >
        <b-list-group-item
          v-for="guide in guidesList"
          :key="guide.id"
          button
          class="d-flex justify-content-between align-items-center"
          :class="{ 'active': selectedId === guide.id }"
          @click="selectGuide(guide)"
        >
          <div>
            <strong>{{ guide.title }}</strong>
            <span
              v-if="guide.task_type"
              class="text-muted small ml-2"
            >({{ guide.task_type }})</span>
          </div>
          <feather-icon icon="ChevronRightIcon" />
        </b-list-group-item>
      </b-list-group>
      <p
        v-else
        class="text-muted text-center py-4"
      >
        {{ $t('tasks.guideModal.empty') }}
      </p>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="outline-secondary"
          @click="$emit('input', false)"
        >
          {{ $t('common.cancel') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BListGroup, BListGroupItem, BButton, BSpinner,
  BFormGroup, BInputGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'SelectGuideModal',
  components: {
    BModal,
    BListGroup,
    BListGroupItem,
    BButton,
    BSpinner,
    BFormGroup,
    BFormInput,
    BInputGroup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    getGuideData: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      selectedId: null,
      search: null,
    }
  },
  computed: {
    guidesList() {
      return this.$store.getters['guides/dataList'] || []
    },
    loading() {
      return this.$store.getters['guides/loading']
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.selectedId = null
        this.search = null
        this.loadGuides()
      }
    },
  },
  methods: {
    loadGuides() {
      const param = {
        select: ['guides.id AS id', 'guides.title AS title', 'guides.task_type AS task_type', 'guides.description AS description'],
        where: { 'guides.status': 1 },
        limit: 100,
        start: 0,
      }
      if (this.search) {
        param.or_like = {
          'guides.title': this.search,
          'guides.task_type': this.search,
        }
      } else {
        delete param.or_like
      }
      this.$store.dispatch('guides/getDataList', param)
    },
    async selectGuide(guide) {
      this.getGuideData()
      try {
        await this.$router.push(`/app/tasks/add?id_guides=${guide.id}`)
      } catch (err) {
        if (err?.name !== 'NavigationDuplicated') throw err
      }
      this.$emit('input', false)
    },
  },
}
</script>
